<template>
  <div>
    <BaseTitle :title="$t('menu.report')" />
    <v-card class="mb-7">
      <div class="pa-5">
        <h3>{{ $t('filter') }}</h3>
        <v-row>
          <v-col cols="12" md="4">
            <v-select :items="itemDatatype" :label="$t('form.datatype')" v-model="form.type" @change="changeData">
              <template #item="{item}">{{ $t(item.text) }}</template>
              <template #selection="{item}">{{ $t(item.text) }}</template></v-select
            >
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              :items="level"
              item-value="gradeId"
              item-text="name"
              :label="$t('form.selected')"
              v-model="form.gradeId"
              v-if="form.type === 1"
            />
            <v-select
              :label="$t('form.selected')"
              :items="classroom"
              item-value="classroomId"
              item-text="name"
              v-model="form.classroomId"
              v-if="form.type === 2"
            />
            <v-select
              :label="$t('form.selected')"
              :items="courseReport"
              item-value="courseId"
              item-text="name"
              v-model="form.courseId"
              v-if="form.type === 3"
            />
            <v-select :label="$t('form.selected')" v-if="form.type === ''" />
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="primary" class="btn-primary-custom  mt-4" @click="getData">{{ $t('paginate.show') }}</v-btn>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="primary" class="btn-primary-custom mt-4" @click="resetData" outlined>Reset</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <div class="pa-5">
        <div class="d-flex flex-column flex-md-row justify-md-center align-md-center">
          <slot name="left" />

          <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" :loading="loadingExport" @click="getExport">{{
            $t('content.export')
          }}</v-btn>
          <v-spacer />
          <div v-if="!hideOptionList" class="d-flex justify-center align-center">
            <div>{{ $t('paginate.show') }}</div>
            <v-select :items="optionList" v-model="form.size" required class="mx-2" style="width: 70px" @change="getData" />
            <div>{{ $t('paginate.entries') }}</div>
          </div>
          <v-spacer />
          <v-text-field v-model="form.search" prepend-icon="mdi-magnify" :label="$t('search')" single-line @input="search($event)" />
        </div>
        <v-data-table
          :headers="tableHeader"
          :loading="table.loading"
          :items="items"
          hide-default-footer
          class="table-custom"
          :server-items-length="items.length"
          :options.sync="table.options"
        >
          <!-- <template #top>
            <table-header>
              <template slot="left">
                <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="getExport">{{ $t('content.export') }}</v-btn>
              </template>
            </table-header>
          </template> -->
          <template #item.status="{ item }">
            <strong v-if="item.status == true" class="green--text font-italic">{{ $t('form.active') }}</strong>
            <strong v-if="item.status == false" class="red--text font-italic">{{ $t('form.noactive') }}</strong>
          </template>
          <template #no-data>
            <NoData />
          </template>
        </v-data-table>
        <table-footer @fetch="getData" />
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
// import TableHeader from '@/components/table/TableHeader';
import TableFooter from '@/components/table/TableFooter';
import NoData from '@/components/table/NoData';
import ripple from 'vuetify/lib/directives/ripple';

export default {
  name: 'MasterReportSchool',
  directives: {
    ripple
  },
  props: {
    hideOptionList: {
      type: Boolean,
      value: false
    }
  },
  components: {
    BaseTitle,
    // TableHeader,
    TableFooter,
    NoData
  },
  computed: {
    ...mapGetters({
      itemDatatype: 'Reportschool/itemDatatype',
      itemScore: 'Reportschool/itemScore',
      items: 'Reportschool/items',
      optionList: 'table/optionList'
    }),
    tableHeader() {
      return [
        { text: this.$t('content.classroom'), value: 'classroom' },
        { text: this.$t('menu.course'), value: 'course' },
        { text: this.$t('content.total_teacher'), value: 'totalTeacher' },
        { text: this.$t('content.total_student'), value: 'totalStudent' },
        { text: this.$t('form.status'), value: 'status' }
      ];
    }
  },
  data: () => ({
    form: {
      itemType: '',
      classroomId: '',
      courseId: '',
      gradeId: '',
      type: '',
      size: 10,
      search: ''
    },
    course: [],
    classroom: [],
    level: [],
    loadingExport: false,
    table: {
      loading: false,
      options: {}
    }
  }),
  watch: {
    'table.options': function() {
      this.getData();
    }
  },
  methods: {
    search() {
      this.getData();
    },
    changeData() {
      this.form.classroomId = null;
      this.form.courseId = null;
      this.form.gradeId = null;
      this.form.itemType = null;
      this.getData();
    },
    resetData() {
      this.form.classroomId = null;
      this.form.courseId = null;
      this.form.gradeId = null;
      this.form.itemType = null;
      this.form.type = '';
      this.getData();
    },
    getExport() {
      this.loadingExport = true;
      this.$store
        .dispatch('Reportschool/export')
        .then(response => {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `schooladmin_report_school.xlsx`;
          link.click();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingExport = false));
    },
    getData() {
      this.table.loading = true;
      this.$store.dispatch('Reportschool/fetchList', { ...this.form, ...this.table.options }).finally(() => (this.table.loading = false));
    },
    getDataClass() {
      this.table.loading = true;
      this.$store
        .dispatch('Reportschool/fetchClass')
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .then(res => (this.classroom = res))
        .finally(() => (this.table.loading = false));
    },
    getDataClassLevel() {
      this.table.loading = true;
      this.$store
        .dispatch('Reportschool/fetchClassLevel')
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .then(res => (this.level = res))
        .finally(() => (this.table.loading = false));
    },
    getCourse() {
      this.table.loading = true;
      this.$store
        .dispatch('Reportschool/fetchCourse')
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .then(res => (this.courseReport = res))
        .finally(() => (this.table.loading = false));
    },
    goToCreate() {
      this.$router.push({ name: 'MasterUserCreate' });
    }
  },
  created() {
    this.$store.commit('table/RESET_PAGEABLE');
    this.getData();
    this.getCourse();
    this.getDataClass();
    this.getDataClassLevel();
  }
};
</script>
